const FCA_SECTION_SOURCE_TABLE_KEYS = {
  INVESTOR_CONCENTRATION2: 'INVESTOR_CONCENTRATION',
  PORTFOLIO_LIQUIDITY_PROFILE2: 'PORTFOLIO_LIQUIDITY_PROFILE',
  INVESTOR_LIQUIDITY_PROFILE2: 'INVESTOR_LIQUIDITY_PROFILE',
  INVESTOR_ILLIQUID_ASSET_ARRANGEMENT2: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
  FINANCING_PROFILE2: 'FINANCING_PROFILE',
  FINANCING_PROFILE3: 'FINANCING_PROFILE'
};

export function getFcaSourceTableKey(sectionKey) {
  return FCA_SECTION_SOURCE_TABLE_KEYS[sectionKey] || sectionKey;
}

export function isFcaTableDisabledForFund(fund, sourceTableKey) {
  if (!fund?.visibleTableKeys?.length) return false;
  return !fund.visibleTableKeys.includes(getFcaSourceTableKey(sourceTableKey));
}

export function getVisibleFcaReportSections({
  tableSections,
  sections,
  condensedSections,
  currentFund,
  funds = [],
  isAIF001,
  isMultiFunds = false
}) {
  const visibleFunds = isMultiFunds ? funds : [currentFund];
  const hasVisibilityKeys = visibleFunds.some(fund => Array.isArray(fund?.visibleTableKeys));

  if (isAIF001 || !hasVisibilityKeys) {
    return {
      tableSections,
      sections,
      condensedSections
    };
  }

  const visibleTableKeys = new Set(
    visibleFunds.flatMap(fund =>
      Array.isArray(fund.visibleTableKeys) ? fund.visibleTableKeys : []
    )
  );
  const filteredTableSections = (tableSections || []).filter(section => {
    const sourceTableKey = getFcaSourceTableKey(section?.key);
    return !sourceTableKey || visibleTableKeys.has(sourceTableKey);
  });

  const filteredSections = Object.entries(sections || {}).reduce((acc, [key, value]) => {
    if (visibleTableKeys.has(getFcaSourceTableKey(key))) {
      acc[key] = value;
    }

    return acc;
  }, {});

  const filteredCondensedSections = Object.entries(condensedSections || {}).reduce(
    (acc, [key, value]) => {
      if (visibleTableKeys.has(getFcaSourceTableKey(key))) {
        acc[key] = value;
      }

      return acc;
    },
    {}
  );

  return {
    tableSections: filteredTableSections,
    sections: filteredSections,
    condensedSections: filteredCondensedSections
  };
}
